<h1 mat-dialog-title>Media instellingen</h1>

<mat-dialog-content class="space-y-4">
  <div class="flex items-start justify-between gap-4 py-2">
    <div>
      <p class="font-medium text-sm">Delen</p>
      <p class="text-xs text-gray-500">
        @if (isBulk) {
          Deel {{ itemCount }} geselecteerde media items met onderliggende units
        } @else {
          Maak deze media beschikbaar voor onderliggende units
        }
      </p>
      @if (hasExternalItems) {
        <p class="text-xs text-amber-600 mt-1">
          Sommige items zijn gedeeld door een andere unit en kunnen niet worden aangepast.
        </p>
      }
    </div>
    <mat-slide-toggle
      class="flex-none mt-0.5"
      [checked]="isShared()"
      [disabled]="hasExternalItems"
      (change)="toggleShare($event.checked)"
    />
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="isSaving()">Annuleren</button>
  <button mat-flat-button (click)="save()" [disabled]="isSaving()">
    Opslaan
  </button>
</mat-dialog-actions>
